import LocationPinIcon from '/public/images/ic-pin.svg';
import Image from "next/image";
import {getColor} from "@/styles/ThemeConfig";
import SearchIcon from '/public/images/search.svg';
import styled from "styled-components";
import Link from "next/link";
// import Select from "react-select";
import dynamic from 'next/dynamic';
const ClientOnlySelect = dynamic(() => import('react-select'), { ssr: false });
import {selectStyles} from "@/components/inputs/selectStyles";
import {useRouter} from "next/router";
import NewIcon from "../../../public/images/new.svg";
import ForceSSRLink from "@/components/other/ForceSSRLink";

const Option = styled.div`
    cursor: pointer;
    display: flex; 
    align-items: center; 
    padding: 10px;

    img{
        margin-right: 5px;
    }
    :hover{
        color: ${getColor('gold')};
    }
`;
const VisuallyHiddenLabel = styled.label`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
`;
export default function SelectSearchLocation({size = 'regular', searchOptions})
{
    const router = useRouter();
    const CustomOption = (props) => {
        const { data, innerRef, innerProps,isSelected, isFocused } = props;
        return (
            <ForceSSRLink style={{textDecoration:'none', all:'unset'}}  href={data?.slug ?? '#'}>
            <Option
                ref={innerRef}
                {...innerProps}
                style={{
                    color:isSelected || isFocused ? getColor('gold') : 'black',
                    fontSize: '16px',
                }}
            >
                {
                    data?.flag?.url && <Image
                        src={data?.flag?.url}
                        alt={data?.label}
                        width={20}
                        height={20}
                        style={{
                            width:'20px',
                            height:'auto',
                            objectFit:'contain'
                        }}
                    />
                }

                {
                    !data?.flag?.url && <Image
                        src={LocationPinIcon?.src}
                        alt={data?.label}
                        width={20}
                        height={20}
                        style={{
                            width:'15px',
                            height:'auto',
                            objectFit:'contain'
                        }}
                    />
                }

                {
                    data?.type === 'city' && <span><strong>{data?.name},</strong> {data?.countryName}</span>
                }
                {
                    data?.type === 'country' && <strong>{data?.name}</strong>
                }
                {
                    data?.isNew && <Image src={NewIcon} alt={'NEW'} style={{marginLeft:'5px'}}/>
                }
            </Option>
            </ForceSSRLink>
        );
    };


    return <div  style={{position: 'relative'}}>
        <VisuallyHiddenLabel htmlFor="react-select-search-select-instance-input">Search Locations</VisuallyHiddenLabel>
        <div style={{position: 'relative'}}>

            <Image
                src={SearchIcon}
                alt={'Search'}
                style={{
                    position: 'absolute',
                    left: '20px',
                    top: size === 'small' ? '13px' : '23px',
                    zIndex: 999,
                }}
            />
            <ClientOnlySelect
                id="search-select" // Use a fixed ID
                instanceId="search-select-instance" // Use a fixed ID for instance
                options={searchOptions}
                defaultOptions={searchOptions}
                placeholder={'Start typing destination'}
                onChange={(value) => router?.push(value?.slug ?? '#')}
                closeMenuOnSelect={true}
                blurInputOnSelect={false}
                hideSelectedOptions={false}
                styles={selectStyles(size)}
                components={{
                    IndicatorSeparator: () => null,
                    DropdownIndicator: () => null,
                    Option: CustomOption, // Only assign CustomOption if provided
                }}
            />
        </div>
    </div>;
}
